import { SET_PURCHASE_ORDERS, SET_PURCHASE_ORDERS_FILTERS } from '../actions/main';
import { statePurchaseOrders as initialState } from '../initialState/main';

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_PURCHASE_ORDERS:
            return {
                ...state,
                data: action.requisitions.data,
                totalItems: action.requisitions.totalItems,
                page: action.requisitions.page,
                pageSize: action.requisitions.pageSize,
            };
        case SET_PURCHASE_ORDERS_FILTERS:
            return {
                ...state,
                filters: action.filters
            }
        default: return state;
    }
}

export default reducer;
